module.exports = __webpack_public_path__ + "front/img/edm-bj-xianshang.c4f35b8a.png";